module.exports = __webpack_public_path__ + "img/successful.fce8bbda.png";